/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsKeyValue,
    MelcoModelsKeyValueFromJSON,
    MelcoModelsKeyValueFromJSONTyped,
    MelcoModelsKeyValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsKeyValue
 */
export interface MelcoModelsGenericList1MelcoModelsKeyValue {
    /**
     * 
     * @type {Array<MelcoModelsKeyValue>}
     * @memberof MelcoModelsGenericList1MelcoModelsKeyValue
     */
    list: Array<MelcoModelsKeyValue>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsKeyValue
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsKeyValue
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsKeyValueFromJSON(json: any): MelcoModelsGenericList1MelcoModelsKeyValue {
    return MelcoModelsGenericList1MelcoModelsKeyValueFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsKeyValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsKeyValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsKeyValueFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsKeyValueToJSON(value?: MelcoModelsGenericList1MelcoModelsKeyValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsKeyValueToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


